function parseCalendarDate(value) {
  if (!value) return null;

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    )
      return null;
    return date;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function calcularVigenciaMeses(dataInicio, dataTermino) {
  const inicio = parseCalendarDate(dataInicio);
  const termino = parseCalendarDate(dataTermino);
  if (!inicio || !termino || termino < inicio) return 0;

  let meses =
    (termino.getFullYear() - inicio.getFullYear()) * 12 +
    (termino.getMonth() - inicio.getMonth());

  const candidato = new Date(
    inicio.getFullYear(),
    inicio.getMonth() + meses,
    inicio.getDate()
  );
  if (candidato > termino) meses -= 1;

  return Math.max(1, meses);
}

export function calcularValorTotalVigencia(contrato) {
  if (!contrato || Number(contrato.termino_recorrencia) === 2) return null;

  const meses = calcularVigenciaMeses(
    contrato.data_inicio,
    contrato.data_termino
  );
  const mensal = Number(contrato.valor_total);
  if (
    !meses ||
    contrato.valor_total === null ||
    contrato.valor_total === undefined ||
    !Number.isFinite(mensal)
  )
    return null;

  return Math.round(mensal * meses * 100) / 100;
}
